module.exports = __webpack_public_path__ + "img/front_P1.700ce94f.png";